import classes from "./style.module.scss";

const MessageCard = (props) => {
    const { notoficationInfo } = props;

    return (
        <>
            <div className={`${classes.notifyCardWrapper} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                    <div className='flex items-center mb-5'>
                        <div className={`${classes.informationHeader} flex items-center !mb-0 `}>
                            Message
                        </div>
                    </div>
                    <div className={`${classes.infoWrapper} !block`}>
                        <div className={`${classes.fullWidthInfoCategory}`}>
                            <div className={`${classes.infoValue}`}>{notoficationInfo?.message}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MessageCard